export default __webpack_public_path__ + "static/media/gb.b28716d6.svg";